import React from 'react';
import PropTypes from 'prop-types';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { utilsService } from '../../core/services/utils.service';

@observer
export class DownloadLink extends React.Component {

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    srText: PropTypes.string,
    smallText: PropTypes.string,
    className: PropTypes.string,
    deaden: PropTypes.bool
  }

  static defaultProps = {
    srText: '',
    smallText: '',
    className: '',
    deaden: false
  }

  @observable downloadInProgress = false;

  handleClick = () => {
    const success = (response) => {
      utilsService.announceSuccess('Download');
      this.downloadInProgress = false;
      return response;
    }
    const fail = (err) => {
      utilsService.announceFailure('Download');
      this.downloadInProgress = false;
      throw err;
    }

    if (!this.props.deaden) {
      this.downloadInProgress = true;
      this.props.onClick().then(success, fail);
    }
  }

  render() {
    const downloadInProgress = !!this.downloadInProgress;
    const linkIsDisabled = this.props.deaden || downloadInProgress;
    const InnerTag = linkIsDisabled
      ? 'div'
      : 'button';
    const type = linkIsDisabled
      ? ''
      : 'button';
    const iconClass = linkIsDisabled
      ? ''
      : 'icon icon-download ltblue';
    const subtext = downloadInProgress
      ? 'Downloading...'
      : this.props.smallText;
    const showSubtext = downloadInProgress || this.props.smallText;
    return (<div className={`download-button ${this.props.className}`}>
      <InnerTag type={type} onClick={this.handleClick} className="file-name">
        <span className="sr-only">{this.props.srText}</span>
        {this.props.title}
        <span className={iconClass} aria-hidden="true"></span>
      </InnerTag>
      {showSubtext && <small>{subtext}</small>}
    </div>)
  }
}
